const TOKEN_KEY = "accessToken";
const REFRESH_KEY = "refreshToken";
const BASE_URL = `${process.env.REACT_APP_BASE_URL}`;
const ongoingCol = [
  {
    colName: "Transaction ID",
    colId: "transactionId",
  },
  {
    colName: "Customer Name",
    colId: "customerName",
  },
  {
    colName: "Initiated Date",
    colId: "initiatedDate",
  },
  {
    colName: "Initiated By",
    colId: "initiatedBy",
  },
  {
    colName: "Stage",
    colId: "stage",
  },
  {
    colName: "Assigned To",
    colId: "assignedTo",
  },
];
const allCol = [
  {
    colName: "Transaction ID",
    colId: "transactionId",
  },
  {
    colName: "Customer Name",
    colId: "customerName",
  },
  {
    colName: "Vendor Name",
    colId: "vendorName",
  },
  {
    colName: "Initiated Date",
    colId: "initiatedDate",
  },
  {
    colName: "Last Action Date",
    colId: "lastActionDate",
  },
  {
    colName: "Stage",
    colId: "stage",
  },
  {
    colName: "Assigned To",
    colId: "assignedTo",
  },
  {
    colName: "Currency",
    colId: "currency",
  },
  {
    colName: "Amount",
    colId: "amount",
  },
  {
    colName: "Bank Used",
    colId: "bankUsed",
  },
];

const unassignedCol = [
  {
    colName: "Transaction ID",
    colId: "transactionId",
  },
  {
    colName: "Customer Name",
    colId: "customerName",
  },
  {
    colName: "Initiated Date",
    colId: "initiatedDate",
  },
  {
    colName: "Initiated By",
    colId: "initiatedBy",
  },
];

const userlist = [
  {
    colName: "User ID",
    colId: "id",
  },
  {
    colName: "User Name",
    colId: "name",
  },
  {
    colName: "User Email",
    colId: "email",
  },
  {
    colName: "User Phone",
    colId: "phoneNumber",
  },
  {
    colName: "Is Authorizer",
    colId: "isAuthorizer",
  },
];

const userBankList = [
  {
    colName: "Bank Name",
    colId: "bankName",
  },
  {
    colName: "Account Number",
    colId: "accountNumber",
  },
  {
    colName: "IFSC Code",
    colId: "ifscCode",
  },
  {
    colName: "UCIC/CIF",
    colId: "customerId",
  },
  {
    colName: "Is Primary",
    colId: "isPrimaryAccount",
  },
  {
    colName: "Edit details",
    colId: "edit",
    colKey: "id",
  },
];

const userAdBankList = [
  {
    colName: "Bank Name",
    colId: "bankName",
  },
  {
    colName: "BSR CODE",
    colId: "bsrCode",
  },
  {
    colName: "IFSC Code",
    colId: "ifscCode",
  },
  {
    colName: "UCIC/CIF",
    colId: "customerId",
  },
  {
    colName: "Is Primary",
    colId: "isPrimaryAccount",
  },
  {
    colName: "Edit details",
    colId: "edit",
    colKey: "id",
  },
];

const bankUsers = [
  {
    colName: "Name",
    colId: "name",
  },
  {
    colName: "E-mail",
    colId: "email",
  },
  {
    colName: "Actions",
    colId: "actions",
  },
];

const currencyCodes = [
  "AED",
  "AFN",
  "ALL",
  "AMD",
  "ANG",
  "AOA",
  "ARS",
  "AUD",
  "AWG",
  "AZN",
  "BAM",
  "BBD",
  "BDT",
  "BGN",
  "BHD",
  "BIF",
  "BMD",
  "BND",
  "BOB",
  "BOV",
  "BRL",
  "BSD",
  "BTN",
  "BWP",
  "BYR",
  "BZD",
  "CAD",
  "CDF",
  "CHE",
  "CHF",
  "CHW",
  "CLF",
  "CLP",
  "CNY",
  "COP",
  "COU",
  "CRC",
  "CUC",
  "CUP",
  "CVE",
  "CZK",
  "DJF",
  "DKK",
  "DOP",
  "DZD",
  "EGP",
  "ERN",
  "ETB",
  "EUR",
  "FJD",
  "FKP",
  "GBP",
  "GEL",
  "GHS",
  "GIP",
  "GMD",
  "GNF",
  "GTQ",
  "GYD",
  "HKD",
  "HNL",
  "HRK",
  "HTG",
  "HUF",
  "IDR",
  "ILS",
  "INR",
  "IQD",
  "IRR",
  "ISK",
  "JMD",
  "JOD",
  "JPY",
  "KES",
  "KGS",
  "KHR",
  "KMF",
  "KPW",
  "KRW",
  "KWD",
  "KYD",
  "KZT",
  "LAK",
  "LBP",
  "LKR",
  "LRD",
  "LSL",
  "LTL",
  "LVL",
  "LYD",
  "MAD",
  "MDL",
  "MGA",
  "MKD",
  "MMK",
  "MNT",
  "MOP",
  "MRO",
  "MUR",
  "MVR",
  "MWK",
  "MXN",
  "MXV",
  "MYR",
  "MZN",
  "NAD",
  "NGN",
  "NIO",
  "NOK",
  "NPR",
  "NZD",
  "OMR",
  "PAB",
  "PEN",
  "PGK",
  "PHP",
  "PKR",
  "PLN",
  "PYG",
  "QAR",
  "RON",
  "RSD",
  "RUB",
  "RWF",
  "SAR",
  "SBD",
  "SCR",
  "SDG",
  "SEK",
  "SGD",
  "SHP",
  "SLL",
  "SOS",
  "SRD",
  "SSP",
  "STD",
  "SYP",
  "SZL",
  "THB",
  "TJS",
  "TMT",
  "TND",
  "TOP",
  "TRY",
  "TTD",
  "TWD",
  "TZS",
  "UAH",
  "UGX",
  "USD",
  "USN",
  "USS",
  "UYI",
  "UYU",
  "UZS",
  "VEF",
  "VND",
  "VUV",
  "WST",
  "XAF",
  "XAG",
  "XAU",
  "XBA",
  "XBB",
  "XBC",
  "XBD",
  "XCD",
  "XDR",
  "XFU",
  "XOF",
  "XPD",
  "XPF",
  "XPT",
  "XTS",
  "XXX",
  "YER",
  "ZAR",
  "ZMW",
];

const purposeCodes = [
  //captial account
  "S0017-Acquisition of non-produced non-financial assets (Purchase of intangible assets like patents, copyrights, trademarks etc., land acquired by government, use of natural resources)",
  "S0019-Acquisition of non-produced non-financial assets (Purchase of intangible assets like patents, copyrights, trademarks etc., use of natural resources) – Non-Government",
  "S0026-Capital transfers (Guarantees payments, Investment Grand given by the government/international organisation, exceptionally large Non-life insurance claims) – Government",
  "S0027-Capital  transfers  (Guarantees  payments,  Investment  Grand  given  by  the  Non-government,  exceptionally  large  Non-life  insurance  claims)  –  Non-Government",
  "S0099-Other capital payments not included elsewhere",
  //finacial account
  "S0003-Indian Direct investment abroad (in branches & wholly owned subsidiaries) in equity Shares",
  "S0004-Indian Direct investment abroad (in subsidiaries and associates) in debt instruments",
  "S0005-Indian investment abroad - in real estate",
  "S0006-Repatriation of Foreign Direct Investment made by overseas Investors in India-in equity shares",
  "S0007-Repatriation of Foreign Direct Investment in made by overseas Investors India-in debt instruments",
  "S0008-Repatriation of Foreign Direct Investment made by overseas Investors in India - in real estate",
  //Foreign Portfolio Investments
  "S0001-Indian Portfolio investment abroad - in equity shares",
  "S0002-Indian Portfolio investment abroad - in debt instruments",
  "S0009-Repatriation of Foreign Portfolio Investment made by overseas Investors in India - in equity shares",
  "S0010-Repatriation of Foreign Portfolio Investment made by overseas Investors in India - in debt instruments",
  //External Commercial Borrowings
  "S0011-Loans extended to Non-Residents",
  "S0012-Repayment of long & medium term loans with original maturity above one year received from Non-Residents",
  //Short term Loans
  "S0013-Repayment of short term loans with original maturity up to one year received from Non-Residents",
  //Banking Capital
  "S0014-Repatriation of Non-Resident Deposits (FCNR(B)/NR(E)RA",
  "S0015-Repayment of loans & overdrafts taken by ADs on their own",
  "S0016-Sale of a foreign currency against another foreign currency",
  //   Financial Derivatives and Others
  "S0020-Payments made on account of margin payments, premium payment and settlement amount etc. under Financial derivative",
  "S0021-Payments made on account of sale of share under Employee stock option",
  "S0022-Investment in Indian Depositories Receipts (IDRs)",
  "S0023-Opening of foreign currency account abroad with a bank",
  //   External Assistance
  "S0024-External Assistance extended by India. e.g. Loans and advances extended by India to Foreign governments under",
  "S0025-Repayments made on account of External Assistance received by India.",
  //   Imports
  "S0101-Advance payment against imports made to countries other than Nepal and Bhutan",
  "S0102-Payment towards imports- settlement of invoice other than Nepal and Bhutan",
  "S0103-Imports by diplomatic missions other than Nepal and Bhutan",
  "S0104-Intermediary trade/transit trade, i.e., third country export passing through India",
  "S0108-Goods acquired under merchanting/Payment against import leg of merchanting trade",
  "S0109-Payments made for Imports from Nepal and Bhutan, if any",
  //   Transport
  "S0201-Payments for surplus freight/passenger fare by foreign shipping companies operating in India",
  "S0202-Payment for operating expenses of Indian shipping companies operating abroad",
  "S0203-Freight on imports - Shipping companies",
  "S0204-Freight on exports - Shipping companies",
  "S0205-Operational leasing/Rental of Vessels (with crew)-Shipping companies",
  "S0206-Booking of passages abroad - Shipping companies",
  "S0207-Payments for surplus freight/passenger fare by foreign Airlines companies operating in India",
  "S0208-Operating expenses of Indian Airlines companies operating",
  "S0209-Freight on imports - Airlines companies",
  "S0210-Freight on exports -  Airlines companies",
  "S0211-Operational leasing/Rental of Vessels (with crew) - Airline companies",
  "S0212-Booking of passages abroad - Airlines companies",
  "S0214-Payments on account of stevedoring, demurrage, port handling charges etc.(Shipping companies)",
  "S0215-Payments on account of stevedoring, demurrage, port handling charges, etc.(Airlines companies)",
  "S0216-Payments for Passenger - Shipping companies",
  "S0217-Other payments by Shipping companies",
  "S0218-Payments for Passenger - Airlines companies",
  "S0219-Other Payments by Airlines companies",
  "S0220-Payments on account of freight under other modes of transport (Internal Waterways, Roadways, Railways, Pipeline transports and others)",
  "S0221-Payments on account of passenger fare under other modes of transport (Internal Waterways, Roadways, Railways, Pipeline transports and others)",
  "S0222-Postal & Courier services by Air",
  "S0223-Postal & Courier services by Sea",
  "S0224-Postal & Courier services by others",
  //travel
  "S0301-Business travel",
  "S0303-Travel for pilgrimage",
  "S0304-Travel for medical treatment",
  "S0305-Travel for education (including fees, hostel expenses etc.)",
  "S0306-Other travel (including holiday trips and payments for settling international credit cards transactions)",
  // Construction Services
  "S0501-Construction of projects abroad by Indian companies including import of goods at project site abroad",
  "S0502-Cost of construction etc. of projects executed by foreign companies in India.",
  //Insurance and Pension Services
  "S0601-Life Insurance premium except term insurance",
  "S0602-Freight insurance - relating to import & export of goods",
  "S0603-Other general insurance premium including reinsurance premium; and term life insurance premium",
  "S0605-Auxiliary services including commission on insurance",
  "S0607-Insurance claim Settlement of non-life insurance; and life insurance (only term insurance)",
  "S0608-Life Insurance Claim Settlements",
  "S0609-Standardised Guarantee Services",
  "S0610-Premium for pension funds",
  "S0611-Periodic pension entitlements e.g. monthly quarterly or yearly payments of pension amounts by Indian Pension Fund",
  "S0612-Invoking of standardised guarantees",
  //Financial Services
  "S0701-Financial intermediation, except investment banking - Bank charges, collection charges, LC charges etc.",
  "S0702-Investment banking – brokerage, under writing commission",
  "S0703-Auxiliary services – charges on operation & regulatory fees, custodial services, depository services etc.",
  //   Telecommunication, Computer & Information Services
  "S0801-Hardware consultancy/implementation",
  "S0802-Software consultancy/implementation",
  "S0803-Data base, data processing charges",
  "S0804-Repair and maintenance of computer and software",
  "S0805-News agency services",
  "S0806-Other information services- Subscription to newspapers",
  "S0807-Off-site software imports",
  "S0808-Telecommunication services including electronic mail services and voice mail services",
  "S0809-Satellite services including space shuttle and rockets etc.",
  //   Charges for the use of intellectual property n.i.e
  "S0901-Franchises services",
  "S0902-Payment for use, through licensing arrangements, of produced originals or prototypes (such as manuscripts and films), patents, copyrights, trademarks and industrial processes etc.",
  // Other Business Services
  "S1002-Trade related services – commission on exports/imports",
  "S1003-Operational leasing services (other than financial leasing) without operating crew, including charter hire- Airlines companies",
  "S1004-Legal services",
  "S1005-Accounting, auditing, book-keeping services",
  "S1006-Business and management consultancy and public relations",
  "S1007-Advertising, trade fair service",
  "S1008-Research & Development services",
  "S1009-Architectural services",
  "S1010-Agricultural services like protection against insects & disease, increasing of harvest yields, forestry services.",
  "S1011-Payments for maintenance of offices abroad",
  "S1013-Environmental Services",
  "S1014-Engineering Services",
  "S1015-Tax consulting services",
  "S1016-Market research and public opinion polling service",
  "S1017-Publishing and printing services",
  "S1018-Mining services like on–site processing services analysis of",
  "S1020-Commission agent services",
  "S1021-Wholesale and retailing trade services.",
  "S1022-Operational leasing services (other than financial leasing) without operating crew, including charter hire- Shipping",
  "S1023-Other Technical Services including scientific/space services.",
  "S1099-Other services not included elsewhere",
  // Personal, Cultural & Recreational services
  "S1101-Audio-visual and related services like Motion picture and video tape production, distribution and projection services.",
  "S1103-Radio and television production, distribution and transmission services",
  "S1104-Entertainment services",
  "S1105-Museums, library and archival services",
  "S1106-Recreation and sporting activities services",
  "S1107-Education (e.g. fees for correspondence courses abroad)",
  "S1108-Health Service (payment towards services received from hospitals, doctors, nurses, paramedical and similar services etc. rendered remotely or on-site)",
  "S1109-Other Personal, Cultural & Recreational services",
  // Govt. not included elsewhere (G.n.i.e.)
  "S1201-Maintenance of Indian embassies abroad",
  "S1202-Remittances by foreign embassies in India",
  // Secondary Income
  "S1301-Remittance for family maintenance and savings",
  "S1302-Remittance towards personal gifts and donations",
  "S1303-Remittance towards donations to religious and charitable institutions abroad",
  "S1304-Remittance towards grants and donations to other governments and charitable institutions established by the",
  "S1305-Contributions/donations by the Government to international institutions",
  "S1306-Remittance towards payment/refund of taxes.",
  "S1307-Outflows on account of migrant transfers including personal",
  // Primary Income
  "S1401-Compensation of employees",
  "S1402-Remittance towards intereston Non-Resident deposits (FCNR(B)/NR(E)RA, etc.)",
  "S1403-Remittance towards interest on loans from Non-Residents (ST/MT/LT loans) e.g. External Commercial Borrowings, Trade Credits, etc.",
  "S1405-Remittance towards interest payment by ADs on their own account (to VOSTRO a/c holders or the OD on NOSTRO a/c.)",
  "S1408-Remittance of profit by FDI enterprises in India (by branches of foreign companies including bank branches)",
  "S1409-Remittance of dividends by FDI enterprises in India (other than branches) on equity and investment fund shares",
  "S1410-Payment of interest by FDI enterprises in India to their Parent company abroad.",
  "S1411-Remittance of interest income on account of Portfolio Investment in India",
  "S1412-Remittance of dividends on account of Portfolio Investment in India on equity and investment fund shares",
  // Others
  "S1501-Refunds / rebates / reduction in invoice value on account of",
  "S1502-Reversal of wrong entries, refunds of amount remitted for non-exports",
  "S1503-Payments by residents for international bidding",
  "S1504-Notional sales when export bills negotiated/ purchased/ discounted are dishonored/ crystallised/ cancelled and reversed from suspense account",
  "S1505-Deemed Imports (exports between SEZ, EPZs and Domestic tariff areas)",
  // Maintenance and repair services n.i.e
  "S1601-Payments on account of maintenance and repair services rendered for Vessels, ships, boats, warships, etc.",
  "S1602-Payments on account of maintenance and repair services rendered for aircrafts, space shuttles, rockets, military aircrafts,",
  // Manufacturing services (goods for processing)
  "S1701-Payments for processing of goods",
];

const purposeCodesInward = [
  {
    value: "P0102",
    label:
      "P0102 - Realisation of export bills (in respect of goods) sent on collection (full invoice value)",
  },
  {
    value: "P0103",
    label:
      "P0103 - Advance receipts against export contracts, which will be covered later by GR/PP/SOFTEX/SDF",
  },
  { value: "P0801", label: "P0801 - Hardware consultancy/implementation" },
  {
    value: "P0802",
    label:
      "P0802 - Software consultancy/implementation (other than those covered in SOFTEX form)",
  },
  { value: "P0803", label: "P0803 - Data base, data processing charges" },
  {
    value: "P0804",
    label: "P0804 - Repair and maintenance of computer and software",
  },
  {
    value: "P0806",
    label:
      "P0806 - Other information services - Subscription to newspapers, periodicals, etc.",
  },

  { value: "P0807", label: "P0807 - Off site Software Exports" },
  {
    value: "P0901",
    label:
      "P0901 - Franchises services  patents,copy rights, trade marks, industrial processes, franchises etc.",
  },
  {
    value: "P0902",
    label:
      "P0902 - Receipts for use, through licensing arrangements, of produced originals or prototypes (such as manuscripts and films)",
  },
  {
    value: "P1002",
    label: "P1002 - Trade related services  Commission on exports/imports",
  },
  { value: "P1004", label: "P1004 - Legal services" },
  {
    value: "P1005",
    label:
      "P1005 - Accounting, auditing, book keeping and tax consulting services",
  },
  {
    value: "P1006",
    label:
      "P1006 - Business and management consultancy and public relations services",
  },
  {
    value: "P1007",
    label:
      "P1007 - Advertising, trade fair, market research and public opinion polling services",
  },
  { value: "P1008", label: "P1008 - Research & Development services" },
  { value: "P1014", label: "P1014 - Engineering Services" },
  {
    value: "P1016",
    label: "P1016 - Market research and public opinion polling service",
  },
  { value: "P1017", label: "P1017 - Publishing and printing services" },
  { value: "P1019", label: "P1019 - Commission agent services" },
  { value: "P1020", label: "P1020 - Wholesale and retailing trade services" },
  {
    value: "P1022",
    label:
      "P1022 - Other Technical Services including scientific/space services",
  },
  {
    value: "P1109",
    label: "P1109 - Other Personal, Cultural & Recreational services",
  },
  {
    value: "P1101",
    label: "P1101 - Audio-visual and related services",
  },
  {
    value: "P1107",
    label: "P1107 - Educational Services",
  },
  { value: "P1501", label: "P1501 - Refunds / rebates on account of imports" },
  {
    value: "P1502",
    label:
      "P1502 - Reversal of wrong entries, refunds of amount remitted for non-imports",
  },
  {
    value: "P1701",
    label: "P1701 - Receipts on account of processing of goods",
  },
];

export const MetaDataFileList = [
  {
    text: "Invoice",
    value: "INVOICE",
  },

  {
    text: "15CB",
    value: "CB15",
  },
  {
    text: "15CA",
    value: "CA15",
  },
  {
    text: "Form A2",
    value: "A2_FORM",
  },

  {
    text: "Fema Declaration",
    value: "FEMA_DECLARATION",
  },
  {
    text: "Declaration for not having a credit facility",
    value: "DECLARATION_FOR_NOT_HAVING_A_CREDIT_FACILITY",
  },
  {
    text: "Agreement if Required",
    value: "AGREEMENT_IF_REQUIRED",
  },
  {
    text: "Swift Copy",
    value: "SWIFT_COPY",
  },

  {
    text: "Debit Advice",
    value: "DEBIT_ADVICE",
  },
];
export const TransactionFilesUpload = [
  {
    text: "Invoice",
    value: "INVOICE",
  },

  {
    text: "15CB",
    value: "CB15",
  },
  {
    text: "15CA",
    value: "CA15",
  },
  {
    text: "Form A2",
    value: "A2_FORM",
  },

  {
    text: "Fema Declaration",
    value: "FEMA_DECLARATION",
  },
  {
    text: "Declaration for not having a credit facility",
    value: "DECLARATION_FOR_NOT_HAVING_A_CREDIT_FACILITY",
  },
  {
    text: "Agreement if Required",
    value: "AGREEMENT_IF_REQUIRED",
  },
  {
    text: "Swift Copy",
    value: "SWIFT_COPY",
  },

  {
    text: "Debit Advice",
    value: "DEBIT_ADVICE",
  },
  {
    text: "Others",
    value: "OTHER_DOCUMENT_TYPE",
  },
];
export const TransactionFilesUploadInward = [
  {
    text: "Invoice",
    value: "INVOICE",
  },
  {
    text: "Credit Advice",
    value: "CREDIT_ADVISE",
  },
  {
    text: "MT103",
    value: "MT103",
  },
  {
    text: "FIRA",
    value: "FIRA",
  },
  {
    text: "FIRC",
    value: "FIRC",
  },
  {
    text: "Supporting Document",
    value: "SUPPORTING_DOCUMENT",
  },
  {
    text: "Others",
    value: "OTHER_DOCUMENT_TYPE",
  },
];
export const DocList = [
  {
    text: "No PE",
    value: "NO_PE",
  },
  {
    text: "TRC ",
    value: "TRC",
  },

  {
    text: "10F",
    value: "TEN_F",
  },
  {
    text: "Others",
    value: "OTHER_DOCUMENT_TYPE",
  },
];
export const OrgDocList = [
  {
    text: "Balance Sheet",
    value: "BALANCE_SHEET",
  },
  {
    text: "Account Statement",
    value: "ACCOUNT_STATEMENT",
  },
];
export const CountryCode = [
  { value: "AD", label: "Andorra" },
  { value: "AE", label: "United Arab Emirates" },
  { value: "AF", label: "Afghanistan" },
  { value: "AG", label: "Antigua and Barbuda" },
  { value: "AI", label: "Anguilla" },
  { value: "AL", label: "Albania" },
  { value: "AM", label: "Armenia" },
  { value: "AO", label: "Angola" },
  { value: "AQ", label: "Antarctica" },
  { value: "AR", label: "Argentina" },
  { value: "AS", label: "American Samoa" },
  { value: "AT", label: "Austria" },
  { value: "AU", label: "Australia" },
  { value: "AW", label: "Aruba" },
  { value: "AX", label: "Åland Islands" },
  { value: "AZ", label: "Azerbaijan" },
  { value: "BA", label: "Bosnia and Herzegovina" },
  { value: "BB", label: "Barbados" },
  { value: "BD", label: "Bangladesh" },
  { value: "BE", label: "Belgium" },
  { value: "BF", label: "Burkina Faso" },
  { value: "BG", label: "Bulgaria" },
  { value: "BH", label: "Bahrain" },
  { value: "BI", label: "Burundi" },
  { value: "BJ", label: "Benin" },
  { value: "BL", label: "Saint Barthélemy" },
  { value: "BM", label: "Bermuda" },
  { value: "BN", label: "Brunei Darussalam" },
  { value: "BO", label: "Bolivia (Plurinational State of)" },
  { value: "BQ", label: "Bonaire, Sint Eustatius and Saba" },
  { value: "BR", label: "Brazil" },
  { value: "BS", label: "Bahamas" },
  { value: "BT", label: "Bhutan" },
  { value: "BV", label: "Bouvet Island" },
  { value: "BW", label: "Botswana" },
  { value: "BY", label: "Belarus" },
  { value: "BZ", label: "Belize" },
  { value: "CA", label: "Canada" },
  { value: "CC", label: "Cocos (Keeling) Islands" },
  { value: "CD", label: "Congo, Democratic Republic of the" },
  { value: "CF", label: "Central African Republic" },
  { value: "CG", label: "Congo" },
  { value: "CH", label: "Switzerland" },
  { value: "CI", label: "Côte d'Ivoire" },
  { value: "CK", label: "Cook Islands" },
  { value: "CL", label: "Chile" },
  { value: "CM", label: "Cameroon" },
  { value: "CN", label: "China" },
  { value: "CO", label: "Colombia" },
  { value: "CR", label: "Costa Rica" },
  { value: "CU", label: "Cuba" },
  { value: "CV", label: "Cabo Verde" },
  { value: "CW", label: "Curaçao" },
  { value: "CX", label: "Christmas Island" },
  { value: "CY", label: "Cyprus" },
  { value: "CZ", label: "Czechia" },
  { value: "DE", label: "Germany" },
  { value: "DJ", label: "Djibouti" },
  { value: "DK", label: "Denmark" },
  { value: "DM", label: "Dominica" },
  { value: "DO", label: "Dominican Republic" },
  { value: "DZ", label: "Algeria" },
  { value: "EC", label: "Ecuador" },
  { value: "EE", label: "Estonia" },
  { value: "EG", label: "Egypt" },
  { value: "EH", label: "Western Sahara" },
  { value: "ER", label: "Eritrea" },
  { value: "ES", label: "Spain" },
  { value: "ET", label: "Ethiopia" },
  { value: "FI", label: "Finland" },
  { value: "FJ", label: "Fiji" },
  { value: "FK", label: "Falkland Islands (Malvinas)" },
  { value: "FM", label: "Micronesia (Federated States of)" },
  { value: "FO", label: "Faroe Islands" },
  { value: "FR", label: "France" },
  { value: "GA", label: "Gabon" },
  {
    value: "GB",
    label: "United Kingdom of Great Britain and Northern Ireland",
  },
  { value: "GD", label: "Grenada" },
  { value: "GE", label: "Georgia" },
  { value: "GF", label: "French Guiana" },
  { value: "GG", label: "Guernsey" },
  { value: "GH", label: "Ghana" },
  { value: "GI", label: "Gibraltar" },
  { value: "GL", label: "Greenland" },
  { value: "GM", label: "Gambia" },
  { value: "GN", label: "Guinea" },
  { value: "GP", label: "Guadeloupe" },
  { value: "GQ", label: "Equatorial Guinea" },
  { value: "GR", label: "Greece" },
  { value: "GS", label: "South Georgia and the South Sandwich Islands" },
  { value: "GT", label: "Guatemala" },
  { value: "GU", label: "Guam" },
  { value: "GW", label: "Guinea-Bissau" },
  { value: "GY", label: "Guyana" },
  { value: "HK", label: "Hong Kong" },
  { value: "HM", label: "Heard Island and McDonald Islands" },
  { value: "HN", label: "Honduras" },
  { value: "HR", label: "Croatia" },
  { value: "HT", label: "Haiti" },
  { value: "HU", label: "Hungary" },
  { value: "ID", label: "Indonesia" },
  { value: "IE", label: "Ireland" },
  { value: "IL", label: "Israel" },
  { value: "IN", label: "India" },
  { value: "IM", label: "Isle of Man" },
  { value: "IO", label: "British Indian Ocean Territory" },
  { value: "IQ", label: "Iraq" },
  { value: "IR", label: "Iran (Islamic Republic of)" },
  { value: "IS", label: "Iceland" },
  { value: "IT", label: "Italy" },
  { value: "JE", label: "Jersey" },
  { value: "JM", label: "Jamaica" },
  { value: "JO", label: "Jordan" },
  { value: "JP", label: "Japan" },
  { value: "KE", label: "Kenya" },
  { value: "KG", label: "Kyrgyzstan" },
  { value: "KH", label: "Cambodia" },
  { value: "KI", label: "Kiribati" },
  { value: "KM", label: "Comoros" },
  { value: "KN", label: "Saint Kitts and Nevis" },
  { value: "KP", label: "Korea (Democratic People's Republic of)" },
  { value: "KR", label: "Korea, Republic of" },
  { value: "KW", label: "Kuwait" },
  { value: "KY", label: "Cayman Islands" },
  { value: "KZ", label: "Kazakhstan" },
  { value: "LA", label: "Lao People's Democratic Republic" },
  { value: "LB", label: "Lebanon" },
  { value: "LC", label: "Saint Lucia" },
  { value: "LI", label: "Liechtenstein" },
  { value: "LK", label: "Sri Lanka" },
  { value: "LR", label: "Liberia" },
  { value: "LS", label: "Lesotho" },
  { value: "LT", label: "Lithuania" },
  { value: "LU", label: "Luxembourg" },
  { value: "LV", label: "Latvia" },
  { value: "LY", label: "Libya" },
  { value: "MA", label: "Morocco" },
  { value: "MC", label: "Monaco" },
  { value: "MD", label: "Moldova, Republic of" },
  { value: "ME", label: "Montenegro" },
  { value: "MF", label: "Saint Martin (French part)" },
  { value: "MG", label: "Madagascar" },
  { value: "MH", label: "Marshall Islands" },
  { value: "MK", label: "North Macedonia" },
  { value: "ML", label: "Mali" },
  { value: "MM", label: "Myanmar" },
  { value: "MN", label: "Mongolia" },
  { value: "MO", label: "Macao" },
  { value: "MP", label: "Northern Mariana Islands" },
  { value: "MQ", label: "Martinique" },
  { value: "MR", label: "Mauritania" },
  { value: "MS", label: "Montserrat" },
  { value: "MT", label: "Malta" },
  { value: "MU", label: "Mauritius" },
  { value: "MV", label: "Maldives" },
  { value: "MW", label: "Malawi" },
  { value: "MX", label: "Mexico" },
  { value: "MY", label: "Malaysia" },
  { value: "MZ", label: "Mozambique" },
  { value: "NA", label: "Namibia" },
  { value: "NC", label: "New Caledonia" },
  { value: "NE", label: "Niger" },
  { value: "NF", label: "Norfolk Island" },
  { value: "NG", label: "Nigeria" },
  { value: "NI", label: "Nicaragua" },
  { value: "NL", label: "Netherlands, Kingdom of the" },
  { value: "NO", label: "Norway" },
  { value: "NP", label: "Nepal" },
  { value: "NR", label: "Nauru" },
  { value: "NU", label: "Niue" },
  { value: "NZ", label: "New Zealand" },
  { value: "OM", label: "Oman" },
  { value: "PA", label: "Panama" },
  { value: "PE", label: "Peru" },
  { value: "PF", label: "French Polynesia" },
  { value: "PG", label: "Papua New Guinea" },
  { value: "PH", label: "Philippines" },
  { value: "PK", label: "Pakistan" },
  { value: "PL", label: "Poland" },
  { value: "PM", label: "Saint Pierre and Miquelon" },
  { value: "PN", label: "Pitcairn" },
  { value: "PR", label: "Puerto Rico" },
  { value: "PS", label: "Palestine, State of" },
  { value: "PT", label: "Portugal" },
  { value: "PW", label: "Palau" },
  { value: "PY", label: "Paraguay" },
  { value: "QA", label: "Qatar" },
  { value: "RE", label: "Réunion" },
  { value: "RO", label: "Romania" },
  { value: "RS", label: "Serbia" },
  { value: "RU", label: "Russian Federation" },
  { value: "RW", label: "Rwanda" },
  { value: "SA", label: "Saudi Arabia" },
  { value: "SB", label: "Solomon Islands" },
  { value: "SC", label: "Seychelles" },
  { value: "SD", label: "Sudan" },
  { value: "SE", label: "Sweden" },
  { value: "SG", label: "Singapore" },
  { value: "SH", label: "Saint Helena, Ascension and Tristan da Cunha" },
  { value: "SI", label: "Slovenia" },
  { value: "SJ", label: "Svalbard and Jan Mayen" },
  { value: "SK", label: "Slovakia" },
  { value: "SL", label: "Sierra Leone" },
  { value: "SM", label: "San Marino" },
  { value: "SN", label: "Senegal" },
  { value: "SO", label: "Somalia" },
  { value: "SR", label: "Suriname" },
  { value: "SS", label: "South Sudan" },
  { value: "ST", label: "Sao Tome and Principe" },
  { value: "SV", label: "El Salvador" },
  { value: "SX", label: "Sint Maarten (Dutch part)" },
  { value: "SY", label: "Syrian Arab Republic" },
  { value: "SZ", label: "Eswatini" },
  { value: "TC", label: "Turks and Caicos Islands" },
  { value: "TD", label: "Chad" },
  { value: "TF", label: "French Southern Territories" },
  { value: "TG", label: "Togo" },
  { value: "TH", label: "Thailand" },
  { value: "TJ", label: "Tajikistan" },
  { value: "TK", label: "Tokelau" },
  { value: "TL", label: "Timor-Leste" },
  { value: "TM", label: "Turkmenistan" },
  { value: "TN", label: "Tunisia" },
  { value: "TO", label: "Tonga" },
  { value: "TR", label: "T�rkiye" },
  { value: "TT", label: "Trinidad and Tobago" },
  { value: "TV", label: "Tuvalu" },
  { value: "TW", label: "Taiwan, Province of China" },
  { value: "TZ", label: "Tanzania, United Republic of" },
  { value: "UA", label: "Ukraine" },
  { value: "UG", label: "Uganda" },
  { value: "UM", label: "United States Minor Outlying Islands" },
  { value: "US", label: "United States of America" },
  { value: "UY", label: "Uruguay" },
  { value: "UZ", label: "Uzbekistan" },
  { value: "VA", label: "Holy See" },
  { value: "VC", label: "Saint Vincent and the Grenadines" },
  { value: "VE", label: "Venezuela (Bolivarian Republic of)" },
  { value: "VG", label: "Virgin Islands (British)" },
  { value: "VI", label: "Virgin Islands (U.S.)" },
  { value: "VN", label: "Viet Nam" },
  { value: "VU", label: "Vanuatu" },
  { value: "WF", label: "Wallis and Futuna" },
  { value: "WS", label: "Samoa" },
  { value: "YE", label: "Yemen" },
  { value: "YT", label: "Mayotte" },
  { value: "ZA", label: "South Africa" },
  { value: "ZM", label: "Zambia" },
  { value: "ZW", label: "Zimbabwe" },
];

export const countryOfIncorporation = [
  {
    label: "Andorra",
    value: "Andorra",
  },
  {
    label: "United Arab Emirates",
    value: "United Arab Emirates",
  },
  {
    label: "Afghanistan",
    value: "Afghanistan",
  },
  {
    label: "Antigua and Barbuda",
    value: "Antigua and Barbuda",
  },
  {
    label: "Anguilla",
    value: "Anguilla",
  },
  {
    label: "Albania",
    value: "Albania",
  },
  {
    label: "Armenia",
    value: "Armenia",
  },
  {
    label: "Angola",
    value: "Angola",
  },
  {
    label: "Antarctica",
    value: "Antarctica",
  },
  {
    label: "Argentina",
    value: "Argentina",
  },
  {
    label: "American Samoa",
    value: "American Samoa",
  },
  {
    label: "Austria",
    value: "Austria",
  },
  {
    label: "Australia",
    value: "Australia",
  },
  {
    label: "Aruba",
    value: "Aruba",
  },
  {
    label: "Åland Islands",
    value: "Åland Islands",
  },
  {
    label: "Azerbaijan",
    value: "Azerbaijan",
  },
  {
    label: "Bosnia and Herzegovina",
    value: "Bosnia and Herzegovina",
  },
  {
    label: "Barbados",
    value: "Barbados",
  },
  {
    label: "Bangladesh",
    value: "Bangladesh",
  },
  {
    label: "Belgium",
    value: "Belgium",
  },
  {
    label: "Burkina Faso",
    value: "Burkina Faso",
  },
  {
    label: "Bulgaria",
    value: "Bulgaria",
  },
  {
    label: "Bahrain",
    value: "Bahrain",
  },
  {
    label: "Burundi",
    value: "Burundi",
  },
  {
    label: "Benin",
    value: "Benin",
  },
  {
    label: "Saint Barthélemy",
    value: "Saint Barthélemy",
  },
  {
    label: "Bermuda",
    value: "Bermuda",
  },
  {
    label: "Brunei Darussalam",
    value: "Brunei Darussalam",
  },
  {
    label: "Bolivia (Plurinational State of)",
    value: "Bolivia (Plurinational State of)",
  },
  {
    label: "Bonaire, Sint Eustatius and Saba",
    value: "Bonaire, Sint Eustatius and Saba",
  },
  {
    label: "Brazil",
    value: "Brazil",
  },
  {
    label: "Bahamas",
    value: "Bahamas",
  },
  {
    label: "Bhutan",
    value: "Bhutan",
  },
  {
    label: "Bouvet Island",
    value: "Bouvet Island",
  },
  {
    label: "Botswana",
    value: "Botswana",
  },
  {
    label: "Belarus",
    value: "Belarus",
  },
  {
    label: "Belize",
    value: "Belize",
  },
  {
    label: "Canada",
    value: "Canada",
  },
  {
    label: "Cocos (Keeling) Islands",
    value: "Cocos (Keeling) Islands",
  },
  {
    label: "Congo, Democratic Republic of the",
    value: "Congo, Democratic Republic of the",
  },
  {
    label: "Central African Republic",
    value: "Central African Republic",
  },
  {
    label: "Congo",
    value: "Congo",
  },
  {
    label: "Switzerland",
    value: "Switzerland",
  },
  {
    label: "Côte d'Ivoire",
    value: "Côte d'Ivoire",
  },
  {
    label: "Cook Islands",
    value: "Cook Islands",
  },
  {
    label: "Chile",
    value: "Chile",
  },
  {
    label: "Cameroon",
    value: "Cameroon",
  },
  {
    label: "China",
    value: "China",
  },
  {
    label: "Colombia",
    value: "Colombia",
  },
  {
    label: "Costa Rica",
    value: "Costa Rica",
  },
  {
    label: "Cuba",
    value: "Cuba",
  },
  {
    label: "Cabo Verde",
    value: "Cabo Verde",
  },
  {
    label: "Curaçao",
    value: "Curaçao",
  },
  {
    label: "Christmas Island",
    value: "Christmas Island",
  },
  {
    label: "Cyprus",
    value: "Cyprus",
  },
  {
    label: "Czechia",
    value: "Czechia",
  },
  {
    label: "Germany",
    value: "Germany",
  },
  {
    label: "Djibouti",
    value: "Djibouti",
  },
  {
    label: "Denmark",
    value: "Denmark",
  },
  {
    label: "Dominica",
    value: "Dominica",
  },
  {
    label: "Dominican Republic",
    value: "Dominican Republic",
  },
  {
    label: "Algeria",
    value: "Algeria",
  },
  {
    label: "Ecuador",
    value: "Ecuador",
  },
  {
    label: "Estonia",
    value: "Estonia",
  },
  {
    label: "Egypt",
    value: "Egypt",
  },
  {
    label: "Western Sahara",
    value: "Western Sahara",
  },
  {
    label: "Eritrea",
    value: "Eritrea",
  },
  {
    label: "Spain",
    value: "Spain",
  },
  {
    label: "Ethiopia",
    value: "Ethiopia",
  },
  {
    label: "Finland",
    value: "Finland",
  },
  {
    label: "Fiji",
    value: "Fiji",
  },
  {
    label: "Falkland Islands (Malvinas)",
    value: "Falkland Islands (Malvinas)",
  },
  {
    label: "Micronesia (Federated States of)",
    value: "Micronesia (Federated States of)",
  },
  {
    label: "Faroe Islands",
    value: "Faroe Islands",
  },
  {
    label: "France",
    value: "France",
  },
  {
    label: "Gabon",
    value: "Gabon",
  },
  {
    label: "United Kingdom of Great Britain and Northern Ireland",
    value: "United Kingdom of Great Britain and Northern Ireland",
  },
  {
    label: "Grenada",
    value: "Grenada",
  },
  {
    label: "Georgia",
    value: "Georgia",
  },
  {
    label: "French Guiana",
    value: "French Guiana",
  },
  {
    label: "Guernsey",
    value: "Guernsey",
  },
  {
    label: "Ghana",
    value: "Ghana",
  },
  {
    label: "Gibraltar",
    value: "Gibraltar",
  },
  {
    label: "Greenland",
    value: "Greenland",
  },
  {
    label: "Gambia",
    value: "Gambia",
  },
  {
    label: "Guinea",
    value: "Guinea",
  },
  {
    label: "Guadeloupe",
    value: "Guadeloupe",
  },
  {
    label: "Equatorial Guinea",
    value: "Equatorial Guinea",
  },
  {
    label: "Greece",
    value: "Greece",
  },
  {
    label: "South Georgia and the South Sandwich Islands",
    value: "South Georgia and the South Sandwich Islands",
  },
  {
    label: "Guatemala",
    value: "Guatemala",
  },
  {
    label: "Guam",
    value: "Guam",
  },
  {
    label: "Guinea-Bissau",
    value: "Guinea-Bissau",
  },
  {
    label: "Guyana",
    value: "Guyana",
  },
  {
    label: "Hong Kong",
    value: "Hong Kong",
  },
  {
    label: "Heard Island and McDonald Islands",
    value: "Heard Island and McDonald Islands",
  },
  {
    label: "Honduras",
    value: "Honduras",
  },
  {
    label: "Croatia",
    value: "Croatia",
  },
  {
    label: "Haiti",
    value: "Haiti",
  },
  {
    label: "Hungary",
    value: "Hungary",
  },
  {
    label: "Indonesia",
    value: "Indonesia",
  },
  {
    label: "Ireland",
    value: "Ireland",
  },
  {
    label: "Israel",
    value: "Israel",
  },
  {
    label: "India",
    value: "India",
  },
  {
    label: "Isle of Man",
    value: "Isle of Man",
  },
  {
    label: "British Indian Ocean Territory",
    value: "British Indian Ocean Territory",
  },
  {
    label: "Iraq",
    value: "Iraq",
  },
  {
    label: "Iran (Islamic Republic of)",
    value: "Iran (Islamic Republic of)",
  },
  {
    label: "Iceland",
    value: "Iceland",
  },
  {
    label: "Italy",
    value: "Italy",
  },
  {
    label: "Jersey",
    value: "Jersey",
  },
  {
    label: "Jamaica",
    value: "Jamaica",
  },
  {
    label: "Jordan",
    value: "Jordan",
  },
  {
    label: "Japan",
    value: "Japan",
  },
  {
    label: "Kenya",
    value: "Kenya",
  },
  {
    label: "Kyrgyzstan",
    value: "Kyrgyzstan",
  },
  {
    label: "Cambodia",
    value: "Cambodia",
  },
  {
    label: "Kiribati",
    value: "Kiribati",
  },
  {
    label: "Comoros",
    value: "Comoros",
  },
  {
    label: "Saint Kitts and Nevis",
    value: "Saint Kitts and Nevis",
  },
  {
    label: "Korea (Democratic People's Republic of)",
    value: "Korea (Democratic People's Republic of)",
  },
  {
    label: "Korea, Republic of",
    value: "Korea, Republic of",
  },
  {
    label: "Kuwait",
    value: "Kuwait",
  },
  {
    label: "Cayman Islands",
    value: "Cayman Islands",
  },
  {
    label: "Kazakhstan",
    value: "Kazakhstan",
  },
  {
    label: "Lao People's Democratic Republic",
    value: "Lao People's Democratic Republic",
  },
  {
    label: "Lebanon",
    value: "Lebanon",
  },
  {
    label: "Saint Lucia",
    value: "Saint Lucia",
  },
  {
    label: "Liechtenstein",
    value: "Liechtenstein",
  },
  {
    label: "Sri Lanka",
    value: "Sri Lanka",
  },
  {
    label: "Liberia",
    value: "Liberia",
  },
  {
    label: "Lesotho",
    value: "Lesotho",
  },
  {
    label: "Lithuania",
    value: "Lithuania",
  },
  {
    label: "Luxembourg",
    value: "Luxembourg",
  },
  {
    label: "Latvia",
    value: "Latvia",
  },
  {
    label: "Libya",
    value: "Libya",
  },
  {
    label: "Morocco",
    value: "Morocco",
  },
  {
    label: "Monaco",
    value: "Monaco",
  },
  {
    label: "Moldova, Republic of",
    value: "Moldova, Republic of",
  },
  {
    label: "Montenegro",
    value: "Montenegro",
  },
  {
    label: "Saint Martin (French part)",
    value: "Saint Martin (French part)",
  },
  {
    label: "Madagascar",
    value: "Madagascar",
  },
  {
    label: "Marshall Islands",
    value: "Marshall Islands",
  },
  {
    label: "North Macedonia",
    value: "North Macedonia",
  },
  {
    label: "Mali",
    value: "Mali",
  },
  {
    label: "Myanmar",
    value: "Myanmar",
  },
  {
    label: "Mongolia",
    value: "Mongolia",
  },
  {
    label: "Macao",
    value: "Macao",
  },
  {
    label: "Northern Mariana Islands",
    value: "Northern Mariana Islands",
  },
  {
    label: "Martinique",
    value: "Martinique",
  },
  {
    label: "Mauritania",
    value: "Mauritania",
  },
  {
    label: "Montserrat",
    value: "Montserrat",
  },
  {
    label: "Malta",
    value: "Malta",
  },
  {
    label: "Mauritius",
    value: "Mauritius",
  },
  {
    label: "Maldives",
    value: "Maldives",
  },
  {
    label: "Malawi",
    value: "Malawi",
  },
  {
    label: "Mexico",
    value: "Mexico",
  },
  {
    label: "Malaysia",
    value: "Malaysia",
  },
  {
    label: "Mozambique",
    value: "Mozambique",
  },
  {
    label: "Namibia",
    value: "Namibia",
  },
  {
    label: "New Caledonia",
    value: "New Caledonia",
  },
  {
    label: "Niger",
    value: "Niger",
  },
  {
    label: "Norfolk Island",
    value: "Norfolk Island",
  },
  {
    label: "Nigeria",
    value: "Nigeria",
  },
  {
    label: "Nicaragua",
    value: "Nicaragua",
  },
  {
    label: "Netherlands, Kingdom of the",
    value: "Netherlands, Kingdom of the",
  },
  {
    label: "Norway",
    value: "Norway",
  },
  {
    label: "Nepal",
    value: "Nepal",
  },
  {
    label: "Nauru",
    value: "Nauru",
  },
  {
    label: "Niue",
    value: "Niue",
  },
  {
    label: "New Zealand",
    value: "New Zealand",
  },
  {
    label: "Oman",
    value: "Oman",
  },
  {
    label: "Panama",
    value: "Panama",
  },
  {
    label: "Peru",
    value: "Peru",
  },
  {
    label: "French Polynesia",
    value: "French Polynesia",
  },
  {
    label: "Papua New Guinea",
    value: "Papua New Guinea",
  },
  {
    label: "Philippines",
    value: "Philippines",
  },
  {
    label: "Pakistan",
    value: "Pakistan",
  },
  {
    label: "Poland",
    value: "Poland",
  },
  {
    label: "Saint Pierre and Miquelon",
    value: "Saint Pierre and Miquelon",
  },
  {
    label: "Pitcairn",
    value: "Pitcairn",
  },
  {
    label: "Puerto Rico",
    value: "Puerto Rico",
  },
  {
    label: "Palestine, State of",
    value: "Palestine, State of",
  },
  {
    label: "Portugal",
    value: "Portugal",
  },
  {
    label: "Palau",
    value: "Palau",
  },
  {
    label: "Paraguay",
    value: "Paraguay",
  },
  {
    label: "Qatar",
    value: "Qatar",
  },
  {
    label: "Réunion",
    value: "Réunion",
  },
  {
    label: "Romania",
    value: "Romania",
  },
  {
    label: "Serbia",
    value: "Serbia",
  },
  {
    label: "Russian Federation",
    value: "Russian Federation",
  },
  {
    label: "Rwanda",
    value: "Rwanda",
  },
  {
    label: "Saudi Arabia",
    value: "Saudi Arabia",
  },
  {
    label: "Solomon Islands",
    value: "Solomon Islands",
  },
  {
    label: "Seychelles",
    value: "Seychelles",
  },
  {
    label: "Sudan",
    value: "Sudan",
  },
  {
    label: "Sweden",
    value: "Sweden",
  },
  {
    label: "Singapore",
    value: "Singapore",
  },
  {
    label: "Saint Helena, Ascension and Tristan da Cunha",
    value: "Saint Helena, Ascension and Tristan da Cunha",
  },
  {
    label: "Slovenia",
    value: "Slovenia",
  },
  {
    label: "Svalbard and Jan Mayen",
    value: "Svalbard and Jan Mayen",
  },
  {
    label: "Slovakia",
    value: "Slovakia",
  },
  {
    label: "Sierra Leone",
    value: "Sierra Leone",
  },
  {
    label: "San Marino",
    value: "San Marino",
  },
  {
    label: "Senegal",
    value: "Senegal",
  },
  {
    label: "Somalia",
    value: "Somalia",
  },
  {
    label: "Suriname",
    value: "Suriname",
  },
  {
    label: "South Sudan",
    value: "South Sudan",
  },
  {
    label: "Sao Tome and Principe",
    value: "Sao Tome and Principe",
  },
  {
    label: "El Salvador",
    value: "El Salvador",
  },
  {
    label: "Sint Maarten (Dutch part)",
    value: "Sint Maarten (Dutch part)",
  },
  {
    label: "Syrian Arab Republic",
    value: "Syrian Arab Republic",
  },
  {
    label: "Eswatini",
    value: "Eswatini",
  },
  {
    label: "Turks and Caicos Islands",
    value: "Turks and Caicos Islands",
  },
  {
    label: "Chad",
    value: "Chad",
  },
  {
    label: "French Southern Territories",
    value: "French Southern Territories",
  },
  {
    label: "Togo",
    value: "Togo",
  },
  {
    label: "Thailand",
    value: "Thailand",
  },
  {
    label: "Tajikistan",
    value: "Tajikistan",
  },
  {
    label: "Tokelau",
    value: "Tokelau",
  },
  {
    label: "Timor-Leste",
    value: "Timor-Leste",
  },
  {
    label: "Turkmenistan",
    value: "Turkmenistan",
  },
  {
    label: "Tunisia",
    value: "Tunisia",
  },
  {
    label: "Tonga",
    value: "Tonga",
  },
  {
    label: "T�rkiye",
    value: "T�rkiye",
  },
  {
    label: "Trinidad and Tobago",
    value: "Trinidad and Tobago",
  },
  {
    label: "Tuvalu",
    value: "Tuvalu",
  },
  {
    label: "Taiwan, Province of China",
    value: "Taiwan, Province of China",
  },
  {
    label: "Tanzania, United Republic of",
    value: "Tanzania, United Republic of",
  },
  {
    label: "Ukraine",
    value: "Ukraine",
  },
  {
    label: "Uganda",
    value: "Uganda",
  },
  {
    label: "United States Minor Outlying Islands",
    value: "United States Minor Outlying Islands",
  },
  {
    label: "United States of America",
    value: "United States of America",
  },
  {
    label: "Uruguay",
    value: "Uruguay",
  },
  {
    label: "Uzbekistan",
    value: "Uzbekistan",
  },
  {
    label: "Holy See",
    value: "Holy See",
  },
  {
    label: "Saint Vincent and the Grenadines",
    value: "Saint Vincent and the Grenadines",
  },
  {
    label: "Venezuela (Bolivarian Republic of)",
    value: "Venezuela (Bolivarian Republic of)",
  },
  {
    label: "Virgin Islands (British)",
    value: "Virgin Islands (British)",
  },
  {
    label: "Virgin Islands (U.S.)",
    value: "Virgin Islands (U.S.)",
  },
  {
    label: "Viet Nam",
    value: "Viet Nam",
  },
  {
    label: "Vanuatu",
    value: "Vanuatu",
  },
  {
    label: "Wallis and Futuna",
    value: "Wallis and Futuna",
  },
  {
    label: "Samoa",
    value: "Samoa",
  },
  {
    label: "Yemen",
    value: "Yemen",
  },
  {
    label: "Mayotte",
    value: "Mayotte",
  },
  {
    label: "South Africa",
    value: "South Africa",
  },
  {
    label: "Zambia",
    value: "Zambia",
  },
  {
    label: "Zimbabwe",
    value: "Zimbabwe",
  },
];

export const inwardCurrencies = [
  { value: "USD", label: "USD" },
  { value: "GBP", label: "GBP" },
  { value: "EUR", label: "EUR" },
  { value: "AUD", label: "AUD" },
  { value: "SGD", label: "SGD" },
  { value: "HKD", label: "HKD" },
  { value: "NOK", label: "NOK" },
  { value: "PLN", label: "PLN" },
  { value: "SEK", label: "SEK" },
  { value: "CHF", label: "CHF" },
  { value: "CZK", label: "CZK" },
  { value: "DKK", label: "DKK" },
  { value: "AED", label: "AED" },
];

export const inwardStages = [
  {
    label: "initiated",
    value: "INITIATED",
  },
  {
    label: "txn initiated",
    value: "TRANSACTION_INITIATED",
  },
  {
    label: "completed",
    value: "COMPLETED",
  },
  {
    label: "approved",
    value: "APPROVED",
  },
  {
    label: "dropped",
    value: "DROPPED",
  },
];

export const allowedExtensions = [".jpg", ".jpeg", ".png", ".pdf"];

export const swiftRegex = /^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/;

export const ibanRegex = /^[A-Z]{2}\d{2}[A-Z0-9]{4,30}$/;

export const utrRegex = /^[A-Z]{4}\d{12}$/;

export const udinRegex = /^\d{2}\d{5}[A-Z0-9]{2}[A-Z0-9]{9}$/;

export const onlyNumericDigitsRegex = /^\d+$/;

export const onlyNumericDigitsWithDecimalRegex = /^\d*(\.\d+)?$/;

export const gstRegex =
  /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}[A-Z]{1}[0-9]{1}$/;

export const leiRegex = /^[A-Z0-9]{4}[A-Z0-9]{12}[A-Z0-9]{4}$/;

export const tanRegex = /^[A-Z]{4}\d{5}[A-Z]{1}$/;

export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const websiteRegex =
  /^(https?:\/\/)([\w.-]+)\.([a-zA-Z]{2,})(:\d{1,5})?(\/.*)?$/;

export const phoneRegex = /^[6-9]\d{9}$/;

export const dinRegex = /^\d{8}$/;

export const alphanumericRegex = /^[a-zA-Z0-9\s]+$/;

export const hsnNumberRegex = /^\d{10}$/;

export const cinRegex = /^[a-zA-Z0-9-]+$/;

// export const xflowInwardPurposeCodes = [
//     {
//       value: "P0001",
//       label: "P0001 - Repatriation of Indian investment abroad in equity capital (shares)"
//     },
//     {
//       value: "P0002",
//       label: "P0002 - Repatriation of Indian investment abroad in debt securities"
//     },
//     {
//       value: "P0003",
//       label: "P0003 - Repatriation of Indian investment abroad in branches"
//     },
//     {
//       value: "P0004",
//       label: "P0004 - Repatriation of Indian investment abroad in subsidiaries and associates"
//     },
//     {
//       value: "P0005",
//       label: "P0005 - Repatriation of Indian investment abroad in real estate"
//     },
//     {
//       value: "P0006",
//       label: "P0006 - Foreign direct investment in India in equity"
//     },
//     {
//       value: "P0007",
//       label: "P0007 - Foreign direct investment in India in debt securities"
//     },
//     {
//       value: "P0008",
//       label: "P0008 - Foreign direct investment in India in real estate"
//     },
//     {
//       value: "P0009",
//       label: "P0009 - Foreign portfolio investment in India in equity shares"
//     },
//     {
//       value: "P0010",
//       label: "P0010 - Foreign portfolio investment in India in debt securities including debt funds"
//     },
//     {
//       value: "PO011",
//       label: "P0011 - Repayment of loans extended to Non-Residents"
//     },
//     {
//       value: "P0012",
//       label: "P0012 - Loans from Non-Residents to India"
//     },
//     {
//       value: "P00H",
//       label: "P00H - Receipts o/a Non-Resident deposits (FCNRB/NRERA etc.) ADs should report these even if funds are not 'swapped' into Rupees."
//     },
//     {
//       value: "P0015",
//       label: "P0015 - Loans & overdrafts taken by ADs on their own account. (Any amount of loan credited to the NOSTRO account which may not be swapped into Rupees should also bereported)"
//     },
//     {
//       value: "P0016",
//       label: "P0016 - Purchase of a foreign currency against another currency"
//     },
//     {
//       value: "P0017",
//       label: "P0017 - Sale of intangible assets like patents, copyrights, trade marks etc. by Indian companies"
//     },
//     {
//       value: "P0018",
//       label: "P0018 - Other capital receipts not included elsewhere"
//     },
//     {
//       value: "P0101",
//       label: "P0101 - Value of export bills negotiated / purchased/discounted etc. (covered under GR/PP/SOFTEX/EC copy of shipping bills etc.)"
//     },
//     {
//       value: "P0102",
//       label: "P0102 - Realisation of export bills (in respect of goods) sent on collection (full invoice value)"
//     },
//     {
//       value: "P0103",
//       label: "P0103 - Advance receipts against export contracts (export of goods only)"
//     },
//     {
//       value: "P0104",
//       label: "P0104 - Receipts against export of goods not covered by the GR/PP/SOFTEX/EC copy of shipping bill etc."
//     },
//     {
//       value: "P0105",
//       label: "P0105 - Export bills (in respect of goods) sent on collection"
//     },
//     {
//       value: "P0106",
//       label: "P0106 - Conversion of overdue export bills from NPD to collection mode"
//     },
//     {
//       value: "P0107",
//       label: "P0107 - Realisation of NPD export bills (full value of bill to be reported)"
//     },
//     {
//       value: "P0201",
//       label: "P0201 - Receipts of surplus freight/passenger fare by Indian shipping companies operating abroad"
//     },
//     {
//       value: "P0202",
//       label: "P0202 - Purchases, on account of operating expenses of Foreign shipping companies operating in India"
//     },
//     {
//       value: "P0205",
//       label: "P0205 - Purchases on account of operational leasing (with crew) - Shipping companies"
//     },
//     {
//       value: "P0207",
//       label: "P0207 - Receipts of surplus freight/passenger fare by Indian Airlines companies operating abroad"
//     },
//     {
//       value: "P0208",
//       label: "P0208 - Receipt on account of operating expenses of Foreign Airlines companies operating in India"
//     },
//     {
//       value: "P0211",
//       label: "P0211 - Purchases on account of operational leasing (with crew) - Airlines companies"
//     },
//     {
//       value: "P0213",
//       label: "P0213 - Receipts on account of other transportation services (stevedoring, demurrage, port handling charges etc.)"
//     },
//     {
//       value: "P0301",
//       label: "P0301 - Purchases towards travel (Includes purchases of foreign TCs, currency : notes etc over the counter, by hotels, hospitals, Emporiums, Educational institutions etc. as well as amount received bv TT/SWIFT transfers or debit ."
//     },
//     {
//       value: "P0308",
//       label: "P0308 - FC surrendered by returning Indian tourists"
//     },
//     {
//       value: "P0401",
//       label: "P0401 - Postal services"
//     },
//     {
//       value: "P0402",
//       label: "P0402 - Courier services"
//     },
//     {
//       value: "P0403",
//       label: "P0403 - Telecommunication services"
//     },
//     {
//       value: "P0404",
//       label: "P0404 - Satellite services"
//     },
//     {
//       value: "P0501",
//       label: "P0501 - Receipts for cost of construction of services projects in India"
//     },
//     {
//       value: "P0601",
//       label: "P0601 - Receipts of life insurance premium"
//     },
//     {
//       value: "P0602",
//       label: "P0602 - Receipts of freight insurance - relating to import & export of goods"
//     },
//     {
//       value: "P0603",
//       label: "P0603 - Receipts on account of other general insurance premium"
//     },
//     {
//       value: "P0604",
//       label: "P0604 - Receipts of Reinsurance premium"
//     },
//     {
//       value: "P0605",
//       label: "P0605 - Receipts on account of Auxiliary services (commission on Insurance)"
//     },
//     {
//       value: "P0606",
//       label: "P0606 - Receipts on account of settlement of claims"
//     },
//     {
//       value: "P0701",
//       label: "P0701 - Financial intermediation except investment banking (bank charges, collection charges, LC charges, etc.)"
//     },
//     {
//       value: "P0702",
//       label: "P0702 - Investment banking - brokerage, underwriting commission etc."
//     },
//     {
//       value: "P0703",
//       label: "P0703 - Auxiliary services - charges on operation, regulatory fees, custodial/depository services"
//     },
//     {
//       value: "P0801",
//       label: "P0801 - Hardware consultancy"
//     },
//     {
//       value: "P0802",
//       label: "P0802 - Software implementation/consultancy (other than SOFTEX)"
//     },
//     {
//       value: "P0803",
//       label: "P0803 - Database, data processing charges"
//     },
//     {
//       value: "P0804",
//       label: "P0804 - Repair and maintenance of computer and software"
//     },
//     {
//       value: "P0805",
//       label: "P0805 - News agency services"
//     },
//     {
//       value: "P0806",
//       label: "P0806 - Other information services (subscription to newspapers, periodicals etc.)"
//     },
//     {
//       value: "P0901",
//       label: "P0901 - Franchises services - patents, copyrights, trademarks, industrial processes, franchises etc."
//     },
//     {
//       value: "P0902",
//       label: "P0902 - Receipts for use, through licensing arrangements, of produced originals or prototypes (such as manuscripts and films)"
//     },
//     {
//       value: "P1001",
//       label: "P1001 - Merchanting Services – net receipts (from sale and purchase of goods without crossing the border)"
//     },
//     {
//       value: "P1002",
//       label: "P1002 - Trade related services - Commission on exports/imports"
//     },
//     {
//       value: "P1003",
//       label: "P1003 - Operational leasing services (other than financial leasing) including charter hire"
//     },
//     {
//       value: "P1004",
//       label: "P1004 - Legal services"
//     },
//     {
//       value: "P1005",
//       label: "P1005 - Accounting, auditing, bookkeeping and tax consulting services"
//     },
//     {
//       value: "P1006",
//       label: "P1006 - Business and management consultancy and public relations services"
//     },
//     {
//       value: "P1007",
//       label: "P1007 - Advertising, trade fair, market research and public opinion polling services"
//     },
//     {
//       value: "P1008",
//       label: "P1008 - Research & Development services"
//     },
//     {
//       value: "P1009",
//       label: "P1009 - Architectural, engineering and other technical services"
//     },
//     {
//       value: "P1010",
//       label: "P1010 - Agricultural, mining and on -site processing services - protection against insects & disease, increasing of harvest yields, forestry services, mining services like analysis of ores etc."
//     },
//     {
//       value: "P1011",
//       label: "P1011 - Inward remittance for maintenance of offices in India"
//     },
//     {
//       value: "P1012",
//       label: "P1012 - Distribution services"
//     },
//     {
//       value: "P1013",
//       label: "P1013 - Environmental services"
//     },
//     {
//       value: "P1019",
//       label: "P1019 - Other services not included elsewhere"
//     },
//     {
//       value: "P1101",
//       label: "P1101 - Audio-visual and related services -services and associated fees related to production of motion pictures, rentals, fees received by actors, directors, producers and fees for distribution rights."
//     },
//     {
//       value: "P1102",
//       label: "P1102 - Personal, cultural services such as those related to museums, libraries, archives and sporting activities and fees for correspondence courses of Indian Universities/Institutes"
//     },
//     {
//       value: "P1201",
//       label: "P1201 - Maintenance of foreign embassies in India"
//     },
//     {
//       value: "P1203",
//       label: "P1203 - Maintenance of international institutions (IMF, World Bank, UNICEF, etc.) in India"
//     },
//     {
//       value: "P1301",
//       label: "P1301 - Inward remittance from Indian non-residents towards family maintenance and savings"
//     },
//     {
//       value: "P1302",
//       label: "P1302 - Personal gifts and donations"
//     },
//     {
//       value: "P1303",
//       label: "P1303 - Donations to religious and charitable institutions in India"
//     },
//     {
//       value: "P1304",
//       label: "P1304 - Grants and donations to governments and charitable institutions established by the governments"
//     },
//     {
//       value: "P1306",
//       label: "P1306 - Receipts / Refund of taxes"
//     },
//     {
//       value: "P1401",
//       label: "P1401 - Compensation of employees"
//     },
//     {
//       value: "P1403",
//       label: "P1403 - Inward remittance towards interest on loans extended to non-residents (ST/MT/LT loans)"
//     },
//     {
//       value: "P1404",
//       label: "P1404 - Inward remittance of interest on debt securities - debentures / bonds /FRNsetc"
//     },
//     {
//       value: "P1405",
//       label: "P1405 - Inward remittance towards interest receipts of ADs on their own account (on investments.)"
//     },
//     {
//       value: "P1406",
//       label: "P1406 - Repatriation of profits to India"
//     },
//     {
//       value: "P1407",
//       label: "P1407 - Receipt of dividends by Indians"
//     },
//     {
//       value: "P1501",
//       label: "P1501 - Refunds / rebates on account of imports"
//     },
//     {
//       value: "P1502",
//       label: "P1502 - Reversal of wrong entries, refunds of amount remitted for non-imports"
//     },
//     {
//       value: "P1503",
//       label: "P1503 - Remittances (receipts) by residents under international bidding process"
//     },
//     {
//       value: "P1590",
//       label: "P1590 - Receipts below $10,000 (say Rs 5,00,000)"
//     },
//         {
//           value: "S0001",
//           label: "S0001 - Indian investment abroad in equity capital (shares)"
//         },
//         {
//           value: "S0002",
//           label: "S0002 - Indian investment abroad in debt securities"
//         },
//         {
//           value: "S0003",
//           label: "S0003 - Indian investment abroad in branches"
//         },
//         {
//           value: "S0004",
//           label: "S0004 - Indian investment abroad in subsidiaries and associates"
//         },
//         {
//           value: "S0005",
//           label: "S0005 - Indian investment abroad in real estate"
//         },
//         {
//           value: "S0006",
//           label: "S0006 - Repatriation of Foreign Direct Investment in India in equity shares"
//         },
//         {
//           value: "S0007",
//           label: "S0007 - Repatriation of Foreign Direct Investment in India in debt securities"
//         },
//         {
//           value: "S0008",
//           label: "S0008 - Repatriation of Foreign Direct Investment in India in real estate"
//         },
//         {
//           value: "S0009",
//           label: "S0009 - Repatriation of Foreign Portfolio Investment in India in equity shares"
//         },
//         {
//           value: "S0010",
//           label: "S0010 - Repatriation of Foreign Portfolio Investment in India in debt securities"
//         },
//         {
//           value: "S0011",
//           label: "S0011 - Loans extended to Non-Residents"
//         },
//         {
//           value: "S0012",
//           label: "S0012 - Repayment of loans received from Non-Residents (Long & medium term loans)"
//         },
//         {
//           value: "S0013",
//           label: "S0013 - Repayment of short term loans received from Non-Residents"
//         },
//         {
//           value: "S0014",
//           label: "S0014 - Repatriation of Non-Resident Deposits (FCNRB/N.RERA etc)"
//         },
//         {
//           value: "S0015",
//           label: "S0015 - Repayment of loans & overdrafts taken by ADs on their own account"
//         },
//         {
//           value: "S0016",
//           label: "S0016 - Sale of a foreign currency against another foreign currency"
//         },
//         {
//           value: "S0017",
//           label: "S0017 - Purchase of intangible assets like patents, copyrights, trade marks etc."
//         },
//         {
//           value: "S0018",
//           label: "S0018 - Other capital payments not included elsewhere"
//         },
//         {
//           value: "S0101",
//           label: "S0101 - Advance payment against imports"
//         },
//         {
//           value: "S0102",
//           label: "S0102 - Payment towards imports - settlement of invoice"
//         },
//         {
//           value: "S0103",
//           label: "S0103 - Imports by diplomatic missions"
//         },
//         {
//           value: "S0104",
//           label: "S0104 - Intermediary trade"
//         },
//         {
//           value: "S0190",
//           label: "S0190 - Imports below Rs. 500,000 (For use by ECD offices)"
//         },
//         {
//           value: "S0201",
//           label: "S0201 - Payments for surplus freight/passenger fare by foreign shipping companies operating in India"
//         },
//         {
//           value: "S0202",
//           label: "S0202 - Payment for operating expenses of Indian shipping companies operating abroad"
//         },
//         {
//           value: "S0203",
//           label: "S0203 - Freight on imports - Shipping companies"
//         },
//         {
//           value: "S0204",
//           label: "S0204 - Freight on exports - Shipping companies"
//         },
//         {
//           value: "S0205",
//           label: "S0205 - Operational leasing (with crew) - Shipping companies"
//         },
//         {
//           value: "S0206",
//           label: "S0206 - Booking of passages abroad - Shipping companies"
//         },
//         {
//           value: "S0207",
//           label: "S0207 - Payments for surplus freight/passenger fare by foreign Airlines companies operating in India"
//         },
//         {
//           value: "S0208",
//           label: "S0208 - Operating expenses of Indian Airlines companies operating abroad"
//         },
//         {
//           value: "S0209",
//           label: "S0209 - Freight on imports - Airlines companies"
//         },
//         {
//           value: "S0210",
//           label: "S0210 - Freight on exports - Airlines companies"
//         },
//         {
//           value: "S0211",
//           label: "S0211 - Operational leasing (with crew) - Airlines companies"
//         },
//         {
//           value: "S0212",
//           label: "S0212 - Booking of passages abroad - Airlines companies"
//         },
//         {
//           value: "S0213",
//           label: "S0213 - Payments on account of stevedoring, demurrage, port handling charges etc."
//         },
//         {
//           value: "S0301",
//           label: "S0301 - Remittance towards Business travel"
//         },
//         {
//           value: "S0302",
//           label: "S0302 - Travel under basic travel quota (BTQ)"
//         },
//         {
//           value: "S0303",
//           label: "S0303 - Travel for pilgrimage"
//         },
//         {
//           value: "S0304",
//           label: "S0304 - Travel for medical treatment"
//         },
//         {
//           value: "S0305",
//           label: "S0305 - Travel for education (including fees, hostel expenses etc.)"
//         },
//         {
//           value: "S0306",
//           label: "S0306 - Other travel (international credit cards)"
//         },
//         {
//           value: "S0401",
//           label: "S0401 - Postal services"
//         },
//         {
//           value: "S0402",
//           label: "S0402 - Courier services"
//         },
//         {
//           value: "S0403",
//           label: "S0403 - Telecommunication services"
//         },
//         {
//           value: "S0404",
//           label: "S0404 - Satellite services"
//         },
//         {
//           value: "S0501",
//           label: "S0501 - Construction of projects abroad by Indian companies including import of goods at project site"
//         },
//         {
//           value: "S0502",
//           label: "S0502 - Payments for cost of construction etc. of projects executed by foreign companies in India"
//         },
//         {
//           value: "S0601",
//           label: "S0601 - Payments for Life insurance premium"
//         },
//         {
//           value: "S0602",
//           label: "S0602 - Freight insurance - relating to import & export of goods"
//         },
//         {
//           value: "S0603",
//           label: "S0603 - Other general insurance premium"
//         },
//         {
//           value: "S0604",
//           label: "S0604 - Reinsurance premium"
//         },
//         {
//           value: "S0605",
//           label: "S0605 - Auxiliary services (commission on insurance)"
//         },
//         {
//           value: "S0606",
//           label: "S0606 - Settlement of claims"
//         },
//         {
//           value: "S0701",
//           label: "S0701 - Financial intermediation except investment banking (bank charges, LC charges, leasing commission etc.)"
//         },
//         {
//           value: "S0702",
//           label: "S0702 - Investment banking - brokerage, underwriting commission etc."
//         },
//         {
//           value: "S0703",
//           label: "S0703 - Auxiliary services - operation charges, regulatory fees, custodial/depository services"
//         },
//         {
//           value: "S0801",
//           label: "S0801 - Hardware consultancy"
//         },
//         {
//           value: "S0802",
//           label: "S0802 - Software implementation/consultancy"
//         },
//         {
//           value: "S0803",
//           label: "S0803 - Database, data processing charges"
//         },
//         {
//           value: "S0804",
//           label: "S0804 - Repair and maintenance of computer and software"
//         },
//         {
//           value: "S0805",
//           label: "S0805 - News agency services"
//         },
//         {
//           value: "S0806",
//           label: "S0806 - Other information services (subscription to newspapers, periodicals)"
//         },
//         {
//           value: "S0901",
//           label: "S0901 - Franchises services - patents, copyrights, trademarks, industrial processes etc."
//         },
//         {
//           value: "S0902",
//           label: "S0902 - Payment for use, through licensing arrangements, of produced originals or prototypes (such as manuscripts and films)"
//         },
//         {
//           value: "S1001",
//           label: "S1001 - Merchanting services – net payments (from sale & purchase of goods without crossing the border)"
//         },
//         {
//           value: "S1002",
//           label: "S1002 - Trade related services - commission on exports/imports"
//         },
//         {
//           value: "S1003",
//           label: "S1003 - Operational leasing services (without operating crew), including charter hire"
//         },
//         {
//           value: "S1004",
//           label: "S1004 - Legal services"
//         },
//         {
//           value: "S1005",
//           label: "S1005 - Accounting, auditing, bookkeeping and tax consulting services"
//         },
//         {
//           value: "S1006",
//           label: "S1006 - Business, management consultancy and PR services"
//         },
//         {
//           value: "S1007",
//           label: "S1007 - Advertising, trade fair, market research and public opinion polling services"
//         },
//         {
//           value: "S1008",
//           label: "S1008 - Research & Development services"
//         },
//         {
//           value: "S1009",
//           label: "S1009 - Architectural, engineering and other technical services"
//         },
//         {
//           value: "S1010",
//           label: "S1010 - Agricultural, mining and on-site processing services - protection against insects & disease, increasing of harvest yields, forestry services, mining services like analysis of ores etc."
//         },
//         {
//           value: "S1011",
//           label: "S1011 - Payments for maintenance of offices abroad"
//         },
//         {
//           value: "S1012",
//           label: "S1012 - Distribution services"
//         },
//         {
//           value: "S1013",
//           label: "S1013 - Environmental services"
//         },
//         {
//           value: "S1019",
//           label: "S1019 - Other services not included elsewhere"
//         },
//         {
//           value: "S1101",
//           label: "S1101 - Audio-visual and related services -services and associated fees related to production of motion pictures, rentals, fees received by actors, directors, producers and fees for distribution rights"
//         },
//         {
//           value: "S1102",
//           label: "S1102 - Personal, cultural services such as those related to museums, libraries, archives and sporting activities; fees for correspondence courses abroad."
//         },
//         {
//           value: "S1201",
//           label: "S1201 - Maintenance of Indian embassies abroad"
//         },
//         {
//           value: "S1202",
//           label: "S1202 - Remittances by foreign embassies in India"
//         },
//         {
//           value: "S1301",
//           label: "S1301 - Remittance by non-residents towards family maintenance and savings"
//         },
//         {
//           value: "S1302",
//           label: "S1302 - Remittance towards personal gifts and donations"
//         },
//         {
//           value: "S1303",
//           label: "S1303 - Remittance towards donations to religious and charitable institutions abroad"
//         },
//         {
//           value: "S1304",
//           label: "S1304 - Remittance towards grants and donations to other governments and charitable institutions established by the governments."
//         },
//         {
//           value: "S1305",
//           label: "S1305 - Contributions/donations by the Government to international institutions"
//         },
//         {
//           value: "S1306",
//           label: "S1306 - Remittance towards payment / refund of taxes"
//         },
//         {
//           value: "S1401",
//           label: "S1401 - Compensation of employees"
//         },
//         {
//           value: "S1402",
//           label: "S1402 - Remittance towards interest on Non-Resident deposits (FCNRB/NRERA/ NRNRD/NRSR etc.)"
//         },
//         {
//           value: "S1403",
//           label: "S1403 - Remittance towards interest on loans from Non-Residents (ST/MT/LT loans)"
//         },
//         {
//           value: "S1404",
//           label: "S1404 - Remittance of interest on debt securities (debentures / bonds / FRNs)"
//         },
//         {
//           value: "S1405",
//           label: "S1405 - Remittance towards interest payment by ADs on their own account (to VOSTRO a/c holders or the OD on NOSTRO a/c.)"
//         },
//         {
//           value: "S1406",
//           label: "S1406 - Repatriation of profits"
//         },
//         {
//           value: "S1407",
//           label: "S1407 - Payment/repatriation of dividends"
//         },
//         {
//           value: "S1501",
//           label: "S1501 - Refunds / rebates / reduction in invoice value on account of exports"
//         },
//         {
//           value: "S1502",
//           label: "S1502 - Reversal of wrong entries, refunds of amount remitted for non-exports"
//         },
//         {
//           value: "S1503",
//           label: "S1503 - Payments by residents for international bidding"
//         },
//         {
//           value: "S1504",
//           label: "S1504 - Crystallize/Cancel export bills"
//         }
//   ]

export const xflowInwardPurposeCodes = [
  {
    value: "P0102",
    label:
      "P0102 - Realisation of export bills (in respect of goods) sent on collection (full invoice value)",
  },
  {
    value: "P0103",
    label:
      "P0103 - Advance receipts against export contracts, which will be covered later by GR/PP/SOFTEX/SDF",
  },
  {
    value: "P0201",
    label:
      "P0201 - Receipts of surplus freight/passenger fare by Indian shipping companies operating abroad",
  },
  { value: "P0801", label: "P0801 - Hardware consultancy/implementation" },
  {
    value: "P0802",
    label:
      "P0802 - Software consultancy/implementation (other than those covered in SOFTEX form)",
  },
  { value: "P0803", label: "P0803 - Data base, data processing charges" },
  {
    value: "P0804",
    label: "P0804 - Repair and maintenance of computer and software",
  },
  {
    value: "P0806",
    label:
      "P0806 - Other information services - Subscription to newspapers, periodicals, etc.",
  },
  { value: "P0807", label: "P0807 - Off site Software Exports" },
  {
    value: "P0901",
    label:
      "P0901 - Franchises services – patents,copy rights, trade marks, industrial processes, franchises etc.",
  },
  {
    value: "P0902",
    label:
      "P0902 - Receipts for use, through licensing arrangements, of produced originals or prototypes (such as manuscripts and films)",
  },
  {
    value: "P1002",
    label: "P1002 - Trade related services – Commission on exports/imports",
  },
  {
    value: "P1003",
    label:
      "P1003 - Operational leasing services (other than financial leasing and without operating crew) including charter hire",
  },
  { value: "P1004", label: "P1004 - Legal services" },
  {
    value: "P1005",
    label:
      "P1005 - Accounting, auditing, book keeping and tax consulting services",
  },
  {
    value: "P1006",
    label:
      "P1006 - Business and management consultancy and public relations services",
  },
  {
    value: "P1007",
    label:
      "P1007 - Advertising, trade fair, market research and public opinion polling services",
  },
  { value: "P1008", label: "P1008 - Research & Development services" },
  {
    value: "P1009",
    label: "P1009 - Architectural, engineering and other technical services",
  },
  { value: "P1014", label: "P1014 - Engineering Services" },
  {
    value: "P1016",
    label: "P1016 - Market research and public opinion polling service",
  },
  { value: "P1017", label: "P1017 - Publishing and printing services" },
  { value: "P1019", label: "P1019 - Commission agent services" },
  { value: "P1020", label: "P1020 - Wholesale and retailing trade services" },
  {
    value: "P1022",
    label:
      "P1022 - Other Technical Services including scientific/space services",
  },
  {
    value: "P1109",
    label: "P1109 - Other Personal, Cultural & Recreational services",
  },
  {
    value: "P1101",
    label:
      "P1101 - Audio-visual and related services – services and associated fees related to production of motion pictures, rentals, fees received by actors, directors, producers and fees for distribution rights",
  },
  { value: "P1104", label: "P1104 - Entertainment services" },
  {
    value: "P1107",
    label:
      "P1107 - Educational services (e.g. fees received for correspondence courses offered to non-resident by Indian institutions)",
  },
  { value: "P1306", label: "P1306 - Receipts / Refund of taxes" },
  { value: "P1501", label: "P1501 - Refunds / rebates on account of imports" },
  {
    value: "P1502",
    label:
      "P1502 - Reversal of wrong entries, refunds of amount remitted for non-imports",
  },
  {
    value: "P1701",
    label: "P1701 - Receipts on account of processing of goods",
  },
];

export default {
  TOKEN_KEY,
  REFRESH_KEY,
  BASE_URL,
  ongoingCol,
  allCol,
  unassignedCol,
  currencyCodes,
  purposeCodes,
  userlist,
  DocList,
  OrgDocList,
  userBankList,
  userAdBankList,
  bankUsers,
  inwardCurrencies,
  purposeCodesInward,
  allowedExtensions,
  swiftRegex,
  ibanRegex,
  udinRegex,
  onlyNumericDigitsRegex,
  onlyNumericDigitsWithDecimalRegex,
  leiRegex,
  tanRegex,
  emailRegex,
  websiteRegex,
  dinRegex,
  phoneRegex,
  alphanumericRegex,
  hsnNumberRegex,
  cinRegex,
  xflowInwardPurposeCodes,
};
